export default __webpack_public_path__ + "static/media/header-challenge-active-icon.32e74632.svg";